import React from "react";
import { Grid, Modal, Typography, Stack } from "@mui/material";

import { Button } from "../../../common/styled";
import ModalBox from "../../../../common/ModalBox";

function InvisibleTextModal({ open, handleClose }) {
  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
      >
        <ModalBox sx={{ width: "60vw" }} title="Edit Invisible Text Scanner" handleClose={handleClose}>
          <Grid container p={4} spacing={3}>
            <Grid item xs={12}>
              <Typography>There is no configuration for Invisible Text scanner.</Typography>
            </Grid>
            <Grid item xs={12} textAlign={"right"} pt={4}>
              <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
                <Button variant="outlined" color="secondary" size="modal" onClick={handleClose}>
                  CLose
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </ModalBox>
      </Modal>
    </React.Fragment>
  );
}

export default InvisibleTextModal;
